export const formatTicketSummary = (summary) => String(summary ?? '').replace(/\p{L}/u, (letter) => letter.toLocaleUpperCase());

export const ticketLabel = (ticket) => ticket.JiraIssueKey || `TKT-${ticket.TicketID}`;
